export default class EntitiesConstants {
    static readonly UserEntity = "UserEntity";
    static readonly UserEntityName = "UserEntityName";
    static readonly UserEntityRole = "UserEntityRole";
    static readonly UserEntityId = "UserEntityId";
    static readonly UserEntityPhone = "UserEntityPhone";
    static readonly UserEntityPrefix = "UserEntityPrefix";
    static readonly UserEntityEmail = "UserEntityEmail";
    static readonly UserEntityUsername = "UserEntityUsername";
    static readonly UserEntityPassword = "UserEntityPassword";
    static readonly UserEntityConfirmPassword = "UserEntityConfirmPassword";
    static readonly UserEntityDocument = "UserEntityDocument";
    static readonly UserEntityDocumentType = "UserEntityDocumentType";
    
    static readonly StablishmentEntity = "StablishmentEntity";
    static readonly StablishmentEntityName = "StablishmentEntityName";
    static readonly StablishmentEntityAddress = "StablishmentEntityAddress";
    static readonly StablishmentEntityLatitude = "StablishmentEntityLatitude";
    static readonly StablishmentEntityLongitude = "StablishmentEntityLongitude";
    static readonly StablishmentEntityPhone = "StablishmentEntityPhone";
    static readonly StablishmentEntityType = "StablishmentEntityType";
    static readonly StablishmentEntityEmail = "StablishmentEntityEmail";
    static readonly StablishmentEntityManagerName = "StablishmentEntityManagerName";
    static readonly StablishmentEntitySupervisorId = "StablishmentEntitySupervisorId";
    static readonly StablishmentEntityId = "StablishmentEntityId";
    
    static readonly ShiftEntity = "ShiftEntity";
    static readonly ShiftEntityId = "ShiftEntityId";
    static readonly ShiftEntityStatus = "ShiftEntityStatus";
    static readonly ShiftEntityStartDate = "ShiftEntityStartDate";
    static readonly ShiftEntityEndDate = "ShiftEntityEndDate";
    static readonly ShiftEntityStablishment = "ShiftEntityStablishment";
    static readonly ShiftEntityUser = "ShiftEntityUser";
    static readonly ShiftEntitySchedule = "ShiftEntitySchedule";
    static readonly ShiftEntityWillAttend = "ShiftEntityWillAttend";
    static readonly ShiftEntityCheckedInAt = "ShiftEntityCheckedInAt";
    static readonly ShiftEntityCheckedOutAt = "ShiftEntityCheckedOutAt";
    
    // QR Entity Constants
    static readonly QrBatchEntity = "QrBatchEntity";
    static readonly QrBatchEntityId = "QrBatchEntityId";
    static readonly QrBatchEntityStatus = "QrBatchEntityStatus";
    static readonly QrBatchEntityTycAccepted = "QrBatchEntityTycAccepted";
    static readonly QrBatchEntityStablishment = "QrBatchEntityStablishment";
    static readonly QrBatchEntityCreatedAt = "QrBatchEntityCreatedAt";
}